module.exports = __webpack_public_path__ + "static/media/slider_witches.951d2d4e.gif";